import { initMarketoForm } from "./marketo-form-to-rest-api-v2.js";
import { blockFreeEmails } from "./lib/block-free-emails.js";

blockFreeEmails();

// Initialize Marketo form
initMarketoForm();
